import { types } from "mobx-state-tree";
import { nameof } from "modules/common/services/typescript";

/**
 * Вклад одного квартала в накладные расходы проекта
 */
export const OverheadQuarterPart = types
    .model({
        quarter: types.string,
        overheadPercents: types.number,
        income: types.number,
        ownSpendings: types.number,
        fixedPercents: types.number,
        variableRate: types.number,
        fixed: types.number,
        variable: types.number,
    })
    .named("OverheadQuarterPart");

/**
 * Расшифровка накладных расходов проекта:
 * минимальный порог от выручки + переменная часть по собственным трудозатратам
 */
export const OverheadBreakdown = types
    .model({
        fixed: types.number,
        variable: types.number,
        total: types.number,
        income: types.number,
        ownSpendings: types.number,
        fixedShare: types.number,
        percents: types.number,
        quarters: types.array(OverheadQuarterPart),
    })
    .named("OverheadBreakdown");

export const FinanceValues = types
    .model({
        overhead: types.number,
        production: types.number,
        totalProduction: types.number,
        premiums: types.number,
        profitability: types.number,
        percents: types.map(types.number),
        price: types.number,
        overheadDetails: types.maybeNull(OverheadBreakdown),
    })
    .named("FinanceValues");

export const OrderFinances = types
    .model({
        actual: types.compose(
            FinanceValues,
            types.model({
                waitingQuarter: types.string,
                fixedProduction: types.number,
                fixedPremiums: types.number,
            })
        ),
        plan: FinanceValues,
        today: FinanceValues,
    })
    .named("OrderFinances");

export interface SaveFinanceValues {
    premiumPercents: number;
    planProductionSpendingsPercents: number;
}

export const FinanceValuesFields = {
    premiumPercents: nameof((a: SaveFinanceValues) => a.premiumPercents) as string,
    planProductionSpendingsPercents: nameof((a: SaveFinanceValues) => a.planProductionSpendingsPercents) as string,
};

export const initialFinances = (): typeof OrderFinances.SnapshotType => ({
    plan: initialValues(),
    today: initialValues(),
    actual: {
        ...initialValues(),
        waitingQuarter: "",
        fixedProduction: 0,
        fixedPremiums: 0,
    },
});

export const initialValues = (): typeof FinanceValues.SnapshotType => ({
    overhead: 0,
    premiums: 0,
    price: 0,
    production: 0,
    totalProduction: 0,
    profitability: 0,
    overheadDetails: null,
    percents: {
        overhead: 0,
        premiums: 0,
        price: 0,
        production: 0,
        profitability: 0,
    },
});
